/**
 * 委托书契约。前后端共用。
 *
 * 委托书 = 主流程第 5 步的产物，本身有一套自己的编制流程（8 节，见 SHEET_SECTIONS）。
 * 不要把主流程的第 6~13 步混进这里 —— 那是另一个层级，在别的画面。
 * 详见 docs/step5-design-sheet.md。
 */
export const DESIGN_SHEET_STATUS = {
    DRAFT: 'DRAFT',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    CANCELLED: 'CANCELLED',
};
/**
 * 订货会接口**不提供**、因而导入后会留空的字段。
 * 与 SAP SP0110 的对照见 `docs/integrations-order-fair.md`。
 */
export const ORDER_FAIR_NOT_PROVIDED = [
    'styleNm',
    'apparelTypeCd',
    'itemCd',
    'genderCd',
    'lCategoryCd',
    'mCategoryCd',
    'sCategoryCd',
    'receivingDueDate',
    'charges',
];
// ---------------------------------------------------------------------------
// 请求体
// ---------------------------------------------------------------------------
/** 委托书的来源（工作台按来源分组的维度）。REORDER 预留给加单流程，暂无入口 */
export const SHEET_SOURCE = {
    DEMO: 'DEMO',
    /** 大货 —— 从订货会导入 */
    ORDER_FAIR: 'ORDER_FAIR',
    /** 手动建单（本地检索 / 手输款号） */
    MANUAL: 'MANUAL',
    /** 加单 —— 自社分析建议（预留，暂无创建入口） */
    REORDER: 'REORDER',
};
//# sourceMappingURL=design-sheet.js.map